import React, { memo, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Downshift from "downshift";
import { useTranslation } from "react-i18next";

export default memo(
  function SideTabStockSuggest(props) {
    const { isShow, onSelectedValue } = props;
    const [searchValue, setSearchValue] = useState("");
    const refInput = useRef(null);

    const { t } = useTranslation();
    const [checkOpen, setCheckOpen] = useState(false);

    const marketCode = useSelector((state) => state.gShared.tabNameCurrent.marketCode);
    const indexCode = useSelector((state) => state.gShared.tabNameCurrent.indexCode);
    const basketIndex = useSelector((state) => state.gIndex.basketIndex);
    const [dataSymbol, setDataSymbol] = useState([]);

    const { priceBoardFavSymbols } = useSelector((state) => ({
      priceBoardFavSymbols: state.gShared.priceBoardFavSymbols,
    }));

    const { symbolInfos: storedSymbolInfos } = useSelector(
      (state) => ({
        symbolInfos: state.gSymbol.symbolInfos,
      }),
      (prev, next) => {
        return prev.initTime === next.initTime && prev.symbolInfos?.length === next.symbolInfos?.length;
      }
    );

    const { indexes } = useSelector(
      (state) => ({
        indexes: state.gIndex.indexInfos.map((item) => {
          return {
            code: item.indexCode,
            name: item.indexName,
            marketName: item.marketName,
          };
        }),
        checkFlag: state.gIndex.indexInfos.length,
      }),
      (prev, next) => {
        return prev.checkFlag === next.checkFlag;
      }
    );

    const { symbols } = useSelector(
      (state) => ({
        symbols: state.gSymbol.symbolInfos.map((item) => {
          return {
            code: item.code,
            name: item.symbolName,
            marketName: item.marketName,
          };
        }),
        checkFlag: state.gSymbol.symbolInfos.length,
      }),
      (prev, next) => {
        return prev.checkFlag === next.checkFlag;
      }
    );

    const all = new Array().concat(indexes, symbols);

    //
    useEffect(() => {
      if (isShow) {
        setSearchValue("");
      }
    }, [isShow]);

    //
    const _handleSearchValueChange = (value) => {
      // if(value && value !== "") {
      const type = indexes.some((e) => e.code === value) ? "IDX" : symbols.some((e) => e.code === value) ? "ST" : "";
      onSelectedValue(value, type);
      // }
    };

    const _handleSearchKeyDown = (event) => {
      if (event.defaultPrevented === false && event.keyCode === 13) {
        const _inputValue = event.target.value;
        let _value =
          indexes.find((e) => e.code?.toUpperCase() === _inputValue?.toUpperCase())?.code ??
          symbols.find((e) => e.code?.toUpperCase() === _inputValue?.toUpperCase())?.code ??
          _inputValue;
        _handleSearchValueChange(_value);
      }
    };

    const handleSearchCodeMaketTop = () => {
      let _symbolInfos = [];
      let _symFav = [];
      const _favSymbols = priceBoardFavSymbols ?? [];

      if (marketCode) {
        if (indexCode && indexCode !== "") {
          const symbolsByIndexCode = (basketIndex[indexCode] ?? "").split(",");
          _symbolInfos = storedSymbolInfos.filter(
            (e) => e.marketCode === marketCode && e.securityType !== "CW" && e.securityType !== "BO" && symbolsByIndexCode.indexOf(e.code) >= 0
          );
          _symbolInfos = _symbolInfos.sort((a, b) => (a.code < b.code ? -1 : 1));
        } else {
          _symbolInfos = storedSymbolInfos.filter(
            (e) => e.marketCode === marketCode && e.securityType !== "CW" && e.securityType !== "BO"
          );
          _symbolInfos = _symbolInfos.sort((a, b) => (a.code < b.code ? -1 : 1));
        }
      }
      let trueValue = 1;
      let falseValue = -1;
      _symbolInfos = _symbolInfos.sort((a, b) =>
        Number((a["matchQtty"] ?? "").replace(/,/g, "")) < Number((b["matchQtty"] ?? "").replace(/,/g, "")) ? trueValue : falseValue
      );
      _symFav = storedSymbolInfos.filter((e) => _favSymbols.indexOf(e.code) >= 0).sort((a, b) => (a.code < b.code ? -1 : 1));

      _symFav = _symFav.map((e) => ({
        code: e.code,
        counter: e.counter,
        matchQtty: e.matchQtty,
        // fav: true
      }));

      _symbolInfos = _symbolInfos.map((e) => ({
        code: e.code,
        counter: e.counter,
        matchQtty: e.matchQtty,
      }));

      return setDataSymbol([..._symbolInfos.filter((e, key) => key <= 4), ..._symFav]);
    };

    const handSearchCodeFAV = () => {
      let _symbolInfos = [];
      const _favSymbols = priceBoardFavSymbols ?? [];
      _symbolInfos = storedSymbolInfos.filter((e) => _favSymbols.indexOf(e.code) >= 0).sort((a, b) => (a.code < b.code ? -1 : 1));
      _symbolInfos = _symbolInfos.map((e) => ({
        code: e.code,
        counter: e.counter,
        matchQtty: e.matchQtty,
      }));
      return _symbolInfos;
    };
    //
    return (
      isShow === true && (
        <div className="sidetab-searchbox">
          <Downshift
            onChange={(selection, agrs) => {
              _handleSearchValueChange(selection ? selection.value : "");
            }}
            itemToString={(item) => {
              return item ? item.value : "";
            }}
            onInputValueChange={(value) => {
              setSearchValue(value);
            }}
            inputValue={searchValue}
            onOuterClick={() => {
              setSearchValue("");
            }}
            ref={refInput}
          >
            {({ getInputProps, getItemProps, getLabelProps, getMenuProps, isOpen, inputValue, highlightedIndex, selectedItem }) => {
              let results = [];
              const _favSymbols = priceBoardFavSymbols ?? [];
              if (inputValue && inputValue !== "") {
                results = all
                  .filter((item) => item.code.toUpperCase().includes(inputValue.toUpperCase()))
                  .map((item, index) => {
                    return {
                      value: item.code,
                      content: item.name,
                      marketName: item.marketName,
                      matchIndex: item.code.toUpperCase().indexOf(inputValue.toUpperCase()),
                      fav: _favSymbols.indexOf(item.code) >= 0 ? true : false,
                    };
                  })
                  .sort((a, b) => a.matchIndex - b.matchIndex || a.value.localeCompare(b.value));
              } else {
                let newData = dataSymbol.map((e) => e.code) ?? [];
                results = symbols
                  .filter((e) => newData.includes(e.code))
                  // .sort((a, b) => b.matchQtty - a.matchQtty)
                  .map((item, index) => {
                    return {
                      value: item.code,
                      content: item.name,
                      marketName: item.marketName,
                      matchIndex: item.code.toUpperCase().indexOf(inputValue.toUpperCase()),
                      fav: _favSymbols.indexOf(item.code) >= 0 ? true : false,
                    };
                  })
                  .sort((a, b) => a.fav - b.fav);
              }
              return (
                <div>
                  <input
                    autoFocus
                    placeholder={t("maCKCS")}
                    {...getInputProps({
                      onKeyDown: (e) => {
                        e.key === "Enter" && highlightedIndex === null && _handleSearchKeyDown(e);
                      },
                      onBlur: (e) => {
                        _handleSearchValueChange("");
                        setCheckOpen(false);
                      },
                      onFocus: (e) => {
                        handleSearchCodeMaketTop();
                        setCheckOpen(true);
                      },
                    })}
                  />
                  <ul {...getMenuProps()} className="suggestion-results">
                    {checkOpen
                      ? results.map((item, index) => (
                          <li
                            key={index}
                            {...getItemProps({ key: item.value, index, item })}
                            className={highlightedIndex === index ? "highlighted" : ""}
                            style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                          >
                            {" "}
                            <img
                              onClick={() => {}}
                              src={item.fav ? "/static/img/icon/icon-star-yellow.svg" : "/static/img/icon/icon-star.svg"}
                              alt="img"
                              style={{ marginRight: 3, cursor: "pointer", paddingRight: "5px" }}
                            />
                            <p>
                              {item.value.substr(0, item.matchIndex)}
                              <span className="suggestion-text">{item.value.substr(item.matchIndex, inputValue.length)}</span>
                              {item.value.substr(item.matchIndex + inputValue.length)} - {item.marketName}
                            </p>
                            <p>{item.content}</p>
                          </li>
                        ))
                      : null}
                  </ul>
                </div>
              );
            }}
          </Downshift>
        </div>
      )
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.isShow === nextProps.isShow) {
      return true;
    }
    return false;
  }
);
